import { Typography } from '@material-ui/core';
import React from 'react';
import Link from '../../components/link';
import { HeaderLink } from '../../components/page-layout/header';

interface NavProps {
  links: HeaderLink[];
  pathname?: string;
}

const SidebarNav: React.FC<NavProps> = ({ links, pathname }) => (
  <>
    {links.map((link, index) =>
      'children' in link ? (
        <div key={index} style={{ marginTop: 24 }}>
          <Typography variant="button">{link.label}</Typography>
          <ul style={{ padding: 0, listStyle: 'none', margin: '5px 0' }}>
            <SidebarNav links={link.children} pathname={pathname} />
          </ul>
        </div>
      ) : (
        <li key={index} style={{ paddingBottom: 5, textTransform: 'capitalize' }}>
          <Link to={link.path.replace('/index', '')}>{link.label}</Link>
        </li>
      ),
    )}
  </>
);

export default SidebarNav;
